import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import { DateFns } from "@osu/react-ui";
import reportWebVitals from "./reportWebVitals";
import configureStore from "./storeConfig";
import App from "./App/containers";
import AppleTouchIcon from "./DocumentHead/AppleTouchIcon";
import "./styles/index.scss";
import 'normalize.css';
import resourcesConfig from "./resources-config";
import libraryOptions from "./library-options";
import GoogleTagManager from "./Analytics/components/GoogleTagManager";
import { GTAG_ID, GTM_ID } from "./Analytics/util";

Amplify.configure(resourcesConfig, libraryOptions);
Amplify.configure({
  ...Amplify.getConfig(),
  Storage: {
    S3: {
      bucket: process.env.REACT_APP_STORAGE_BUCKET,
      region: process.env.REACT_APP_STORAGE_REGION,
      identityPoolId: process.env.REACT_APP_AWS_IDENTITY_POOL_ID
    }
  }
});

const store = configureStore();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {(GTM_ID || GTAG_ID) &&  <GoogleTagManager />}
    <Provider store={store}>
      <BrowserRouter>
        <AppleTouchIcon />
        <DateFns.LocalizationProvider>
          <App />
        </DateFns.LocalizationProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
